/* eslint-disable */
export class VerifyLoginRequest {
    md5HashCode!: string;
    codeToVerify!: string | number;

    constructor(obj?: any) {
        if (!obj) {
            return;
        }
        this.md5HashCode = obj.md5CacheKey;
        this.codeToVerify = obj.codeToVerify;
    }
}